"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usersCreateConfig = void 0;
exports.usersCreateConfig = {
    canCreateUsers: true,
    showCreateNewUserButton: true,
};
